import React, { useState } from 'react';
import './LoginForm.css'
import Btn from '../Common/Btn';
import { useNavigate } from 'react-router-dom';

import GoogleIcon from '../../Assets/Icons/Google.svg'

const LoginForm = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [showCreds, setShowCreds] = useState(false);

    const dummyEmail = "admin@dashboard.com";
    const dummyPass = "password123";

    const handleLogin = (e) => {
        e.preventDefault();
        
        if (email === dummyEmail && password === dummyPass) {
            navigate('/home');
        } else {
            alert("Credentials are wrong. Please try again!");
        }
    };


    return ( 
        <div className='LoginForm'>
            <p className='LoginFormTitle'>Welcome Back!</p>
            <p className='LoginFormSub'>Please enter your credintials</p>

            <form className='FormInputs' onSubmit={handleLogin}>
                <div className='InputDiv'>
                    <label className='LoginLabel'>Email</label>
                    <input className='LoginInput' type="email" onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className='InputDiv'>
                    <label className='LoginLabel'>Password</label>
                    <input className='LoginInput' type="password" onChange={(e) => setPassword(e.target.value)} required />
                </div>

                <div className='FormOptions'>
                    <div className="RememberMe">
                        <input type="checkbox" id="remember" name="remember" />
                        <label htmlFor="remember">Remember me</label>
                    </div>

                    <p className='ForgotBtn'>Forgot Password</p>
                </div>

                <div className='LoginBtns'>
                    <Btn BtnType='submit' BtnText='Login' BtnStyle='LoginBtn'/>
                    <Btn BtnText='Sign in with Google' BtnStyle='GoogleBtn' BtnPath='/home' BtnIcon={GoogleIcon}/>
                </div>
            </form>

            <div className='DummyTab' onClick={() => setShowCreds(!showCreds)}>
                <p>{showCreds ? "Hide Test Credentials" : "Show Test Credentials"}</p>
                {showCreds && (
                    <div className='CredsDetail'>
                        <p>Email: <strong>{dummyEmail}</strong></p>
                        <p>Pass: <strong>{dummyPass}</strong></p>
                    </div>
                )}
            </div>
        </div>
     );
}
 
export default LoginForm;